<div class="hero min-h-80" style="background-image: url(assets/images/banner/banner-sub-page.jpeg);">
  <div class="hero-overlay bg-opacity-60"></div>
  <div class="hero-content text-center text-neutral-content">
    <div class="max-w-2xl">
      <h1 class="mb-3 text-5xl font-bold">Featured Speakers</h1>
      <h3 class="text-xl font-light">Presenting with absolute pride</h3>
    </div>
  </div>
</div>
<section class="py-20">
  <div class="container px-5 mx-auto">
    <div class="grid  gap-4 md:gap-4 lg:gap-8 grid-cols-2 md:grid-cols-4 lg:grid-cols-5">
      <div (click)="showModal(speaker)" class="card cursor-pointer group card-compact shadow-lg bg-base-100"
        *ngFor="let speaker of speakers">
        <figure class="max-h-72">
          <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100" [src]="speaker.thumb"
            alt="{{ speaker.speaker }}" (error)="onError($event)" />
        </figure>
        <div class="card-body">
          <div class="text-center">
            <h2 class="text-xl font-bold mb-0">{{ speaker.speaker }}</h2>
            <p class="text-neutral-500">{{ speaker.profile }}</p>
          </div>
          <p>
            {{ speaker.speakerdesc.length > 100 ? (speaker.speakerdesc | slice: 0:100) + '...' : speaker.speakerdesc }}
          </p>
          <div class="card-actions justify-start">
            <a (click)="showModal(speaker);$event.stopPropagation();"><span
                class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read More</span></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<dialog class="modal" #speakerModal>
  <div class="modal-box modal--box p-0 max-w-4xl rounded-2xl flex flex-col md:flex-row">
    <div class="flex-1 static md:sticky top-0 ">
      <div class="profile-pic">
        <img width="600" height="481" [src]="selectedSpeaker?.thumb" (error)="onError($event)"
          class="grayscale hover:grayscale-0 ease-linear duration-100" alt="{{selectedSpeaker?.speaker}}">
      </div>
      <div class="flex bg-primary p-4 justify-between items-center">
        <h3 class="font-bold text-2xl text-neutral">{{ selectedSpeaker?.speaker }}</h3>
        <div class="flex gap-3 text-neutral group [&_a:hover]:text-slate-50 [&_a]:ease-linear [&_a]:duration-100">
          <a *ngIf="selectedSpeaker?.facebook" target="_blank" href="{{selectedSpeaker?.facebook}}"><i
              class="fab fa-facebook-f text-xl"></i></a>
          <a *ngIf="selectedSpeaker?.twitter" target="_blank" href="{{selectedSpeaker?.twitter}}"><i
              class="fab fa-twitter text-xl"></i></a>
          <a *ngIf="selectedSpeaker?.linkedin" target="_blank" href="{{selectedSpeaker?.linkedIn}}"> <i
              class="fab fa-linkedin text-xl"></i></a>
          <a *ngIf="selectedSpeaker?.mail" target="_blank" href="mailto:{{selectedSpeaker?.mail}}">
            <i class="fas fa-paper-plane"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="px-10 flex-1">
      <div class="wrap-content pb-10 border-b-2">
        <h3 class="text-xl mb-3 mt-8 uppercase font-medium">About</h3>
        <p class="text-gray-500 text-sm">{{selectedSpeaker?.speakerdesc}}</p>
      </div>
      <div class="wrap-content pb-10 border-b-2 hidden">
        <h3 class="text-xl mb-3 mt-8 uppercase font-medium">Session</h3>
        <p class="text-sm font-medium">An Intro to Chatbot Development</p>
        <p class="text-gray-500 text-sm">05-Oct-2016 17:00 - 19:00</p>
      </div>
    </div>
    <div class="modal-action hidden md:block z-10">
      <form method="dialog" class="modal-backdrop">
        <button class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-2 top-2"
          (click)="speakerModal.close()">✕</button>
      </form>
    </div>
  </div>
  <div class="modal-action block md:hidden z-10 absolute -top-5 right-0">
    <form method="dialog" class="modal-backdrop">
      <button class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-2 top-2"
        (click)="speakerModal.close()">✕</button>
    </form>
  </div>
</dialog>
